function useRunTimeFilters(options, project) {
  if (!options || (!options.date_range && !options.warehouse_id && !options.cost_center_id && !options.asset_field_filters)) {
    return { hasFilters: false, filters: [] };
  }

  const filters = [];

  if (options.date_range && (options.date_range.start_date || options.date_range.end_date)) {
    const startDate = options.date_range.start_date || "";
    const endDate = options.date_range.end_date || "";

    if (startDate || endDate) {
      filters.push({
        type: "date_range",
        startDate,
        endDate,
      });
    }
  }

  if (options.warehouse_id) {
    const warehouse = project?.warehouses?.find(w => w.id === options.warehouse_id);
    if (warehouse) {
      filters.push({
        type: "warehouse",
        warehouse,
      });
    }
  }

  if (options.cost_center_id) {
    const costCenter = project?.costCenters?.find(cc => cc.id === options.cost_center_id);
    if (costCenter) {
      filters.push({
        type: "cost_center",
        costCenter,
      });
    }
  }

  if (options.asset_field_filters && options.asset_field_filters.length > 0) {
    filters.push({
      type: "asset_field_filters",
      assetFieldFilters: options.asset_field_filters,
    });
  }

  return {
    hasFilters: filters.length > 0,
    filters,
  };
}

export default useRunTimeFilters; 